import { Tooltip } from '@material-ui/core'
import {
  ExecutionDetails,
  ExecutionStatus,
} from '../../../shared/src/data/executionDetails'
import { useExecutions } from '../steps/queries/executions'
import PlayStopButton from './PlayStopButton'

interface PlayExecutionProps {
  execution: ExecutionDetails
  remoteRunning: boolean
}

export default function PlayExecution({
  execution,
  remoteRunning,
}: PlayExecutionProps): JSX.Element {
  const { startScan, stopScan } = useExecutions()
  const handleStart = () => {
    console.log('Starting scan', execution.id)
    startScan({ scanId: execution.id })
    localStorage.setItem('playButtonClicked', 'true');
  }

  const handleStop = () => {
    console.log('Stopping scan', execution.id)
    stopScan({ scanId: execution.id })
    localStorage.setItem('playButtonClicked', 'false');
  }

  const localRunning = localStorage.getItem('playButtonClicked') === 'true';
  return (
    <Tooltip
      title={
        remoteRunning && !localRunning ? 'The engine is already running' : localRunning ? 'Stop execution' : 'Start execution'
      }
      arrow
    >
      <span>
        <PlayStopButton
        remoteRunning={remoteRunning}
          disabled={remoteRunning && !localRunning}
          running={execution.status === ExecutionStatus.Running}
          queued={execution.status === ExecutionStatus.Queued}
          handleStart={handleStart}
          handleStop={handleStop}
          error={execution.status === ExecutionStatus.Failed}
        />
      </span>
    </Tooltip>
  )
}

interface PlayExecutionsProps {
  hasQueued: boolean
  selected: string[]
  refetchPendingExecutions: () => void
  remoteRunning: boolean
}

export function PlayExecutions({
  hasQueued,
  selected,
  refetchPendingExecutions,
  remoteRunning,
}: PlayExecutionsProps): JSX.Element {
  const { startScans, isLoadingStartScans, startScansError, stopScans } =
    useExecutions()
  const handleStart = () => {
    console.log('Starting scans', selected)
    startScans({ ids: selected })
    localStorage.setItem('playButtonClicked', 'true');
    setTimeout(() => {
      refetchPendingExecutions()
    }, 2000)
  }

  const handleStop = () => {
    console.log('Stopping scans', selected)
    stopScans({ ids: selected })
    localStorage.setItem('playButtonClicked', 'false');
    setTimeout(() => {
      refetchPendingExecutions()
    }, 2000)
  }

  const localRunning = localStorage.getItem('playButtonClicked') === 'true';
  return (
    <Tooltip
      title={
        remoteRunning && !localRunning
          ? 'The engine is already running'
          : localRunning ? 'Stop selected executions' : 'Start selected executions'
      }
      arrow
    >
      <span>
        <PlayStopButton
          remoteRunning={remoteRunning}
          disabled={selected.length === 0 || (remoteRunning && !localRunning)}
          running={isLoadingStartScans || hasQueued}
          handleStart={handleStart}
          handleStop={handleStop}
          error={!!startScansError}
        />
      </span>
    </Tooltip>
  )
}
